import { defineComponent as _defineComponent } from 'vue'
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import Vue, {
  computed, PropType
} from 'vue';
import { BcxFormField, BcxFormFieldErrorMessage } from '@/models/BcxForm';
import useResponsiveness from '@/mixins/useResponsiveness';
import { i18nToItemList } from '@/utils/selectItemTools';
import { useVModel } from '@vueuse/core';
import IconX from '@/components/svg/x-circle-2.svg?inline';
import { ExtendedInvoiceItem } from '@/models/Invoice';
import useUser from '@/mixins/useUser';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import useBeforeInput from '@/mixins/useBeforeInput';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePositionsPosition',
  props: {
  position: {
    type: Object as PropType<ExtendedInvoiceItem>,
    required: true
  },
  errorMessages: {
    type: Object as PropType<Record<string, BcxFormFieldErrorMessage>>,
    default: () => ({})
  }
},
  emits: ['update:position'],
  setup(__props, { emit }) {

const props = __props;



const { tUserFallback: t } = useUser('self');
const { isMobileWidth } = useResponsiveness();
const {
  canInvoiceBeEdited, componentPaymentData, findChangedProps, errorMessagesPositions
} = useInvoice();
const { validatePattern } = useBeforeInput();



const vmData = useVModel(props, 'position', emit);

const horizontalGap = isMobileWidth.value ? '16px' : '32px';
const verticalGap = isMobileWidth.value ? '32px' : '24px';

const fields = computed(() => {
  const isMobile = isMobileWidth.value;
  const fields:BcxFormField[] = [
    {
      name: 'amount',
      type: 'number',
      width: isMobile ? '50%' : '18%',
      label: `${t('invoice.positions.form.amount_USERTYPE')}`,
      textOptions: {
        min: 1,
        max: 999,
        hideCharsLeft: true
      },
      disabled: !canInvoiceBeEdited.value
    },
    {
      name: 'displayedUnit',
      type: 'select',
      width: isMobile ? '50%' : '28.5%',
      options: i18nToItemList('invoice.positions.form.unitOptions').value ?? [],
      label: `${t('invoice.positions.form.unit_USERTYPE')}`,
      disabled: !canInvoiceBeEdited.value,
      mode: 'hybrid'
    },
    {
      name: 'costSingle',
      type: 'currency',
      width: isMobile ? '50%' : '28.5%',
      label: `${t('invoice.positions.form.costSingle_USERTYPE')}`,
      currencyOptions: {
        symbol: `${t(`invoice.positions.form.currencyAbbreviation.${componentPaymentData.value.currency}`)}`,
        spaceCurrencySymbol: '28px'
      },
      atBeforeInput: [
        validatePattern('0-9,')
      ],
      disabled: !canInvoiceBeEdited.value
    },
    {
      name: 'netSum',
      type: 'plaintext',
      width: isMobile ? '50%' : '25%',
      label: `${t('invoice.positions.form.netSum_USERTYPE')}`,
      disabled: !canInvoiceBeEdited.value
    },
    {
      name: 'description',
      type: 'text',
      width: '100%',
      label: `${t('invoice.positions.form.description_USERTYPE')}`,
      textOptions: { maxLength: 80 },
      disabled: !canInvoiceBeEdited.value
    }
  ];
  return fields;
});

function onUpdateData(data: ExtendedInvoiceItem) {
  const changed = findChangedProps(data, vmData.value);
  const key = changed[0];
  const index = props.position?.posNo - 1;

  if (changed.length === 1 && errorMessagesPositions.value[index][key]) {
    Vue.delete(errorMessagesPositions.value[index], key);
  }
}

return { __sfc: true,props, t, isMobileWidth, canInvoiceBeEdited, componentPaymentData, findChangedProps, errorMessagesPositions, validatePattern, emit, vmData, horizontalGap, verticalGap, fields, onUpdateData, BCXForm, IconX }
}

})